import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { GoogleSearchBoxInput, Submit } from './styles';

const LocationSearchInput = forwardRef((props, ref) => {
  const { placeholder, onTriggerSearch, ...rest } = props;

  return (
    <GoogleSearchBoxInput>
      <input ref={ref} type="text" style={{ borderRadius: 0 }} placeholder={placeholder} {...rest} />
      <Submit aria-label="Search" onClick={onTriggerSearch} />
    </GoogleSearchBoxInput>
  );
});

LocationSearchInput.defaultProps = {
  placeholder: 'Search',
  // eslint-disable-next-line no-empty-function
  onTriggerSearch: () => {},
};

LocationSearchInput.propTypes = {
  placeholder: PropTypes.string,
  onTriggerSearch: PropTypes.func,
};

export default LocationSearchInput;
